import Skeleton from "@material-ui/lab/Skeleton";
import {
  Button,
  Card,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  TextField,
  MenuItem,
  Paper,
  Select,
  Typography,
  withStyles,
  InputAdornment,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { Component } from "react";
import { connect } from "react-redux";
import { appService } from "../../App/app.service";
import { NumberFormatCustom } from "../../components/CustomNumberFormat";
import {
  customDateFormatterNew,
  dateFormatterMomentV2,
} from "../../util/customFunctions";
import DatePicker from "../../components/DatePicker_v2";
import RepCertificationTable from "./RepCertificationTable";
import RepCertificationTable2 from "./RepCertificationTable2";
import Drilldown from "./Drilldown";
import SingleLevelDrilldown from "../../components/Drilldown/SingleLevelDrilldown";
import ExpectedAcvPage from "../../EnhancedInsights/NewWaterFall/ExpectedAcvPage";
import AddHeaderDescriptionWithHelperText from "../../components/HelperTextDescription";
// import addHeaderdescription from "../../components/HeaderDescription";

// // import QualifiedPipelineTable from './QualifiedPipelineTable';
// import { weekEndingMapping } from './utils';
const styles = (theme) => ({
  root: {},
  content: {},
  buttons: {
    display: "flex",
    justifyContent: "center",
    "& > *": {
      marginLeft: theme.spacing(1),
    },
  },
  inner: {
    height: 375,
    minWidth: 500,
  },
  chart: {
    height: "100%",
  },
  formControl: {
    maxWidth: 250,
  },
  datesFilterContainer: {
    marginTop: 5,
    marginRight: 5,
    marginBottom: 5,
    padding: 10,
    paddingBottom: 10,
    width: "32%",
    [theme.breakpoints.down("md")]: {
      width: "60%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  repTeamFilterContainer: {
    padding: 10,
    margin: 5,
    width: "29%",
    [theme.breakpoints.down("md")]: {
      width: "37%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginLeft: 0,
    },
  },
  acvFilterContainer: {
    padding: 10,
    margin: 5,
    paddingBottom: 2,
    width: "20%",
    [theme.breakpoints.down("md")]: {
      width: "35%",
      marginLeft: 0,
    },
    [theme.breakpoints.down("sm")]: {
      width: "60%",
    },
  },
  stageFilterContainer: {
    padding: 5,
    paddingTop: 10,
    margin: 5,
    paddingBottom: 10,
    width: "10%",
    [theme.breakpoints.down("md")]: {
      width: "20%",
    },
  },
  buttonContainer: {
    padding: 5,
    width: "5%",
    alignSelf: "center",
  },
});

class RepCertification extends Component {
  filters = ["series"];

  state = {
    location: null,
    disabled: ["year", "month", "quarter"],
    filtersForDrilldown: [],
    activeFilters: "",
    activelast: "",
    rep: ["All"],
    repTeam: "rep",
    team: ["All"],
    Cust_Type: ["All"],
    acv: "20,000",
    from: "",
    to: "",
    minDateForTo: "",
    maxDateForTo: "",
    minDateForFrom: "",
    maxDateForFrom: "",
    errorTextFrom: "",
    errorTextTo: "",
    last: "",
    fromDisplay: "",
    toDisplay: "",
    activeFrom: "",
    activeTo: "",
    DrildownFilters: [],
    drilldownTitle: "",
    key: "",
    series: ["All"],
    seriesFilter: ["All"],
  };
  componentDidMount = () => {
    this.props.getCertificationFilters();
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.RepCertificationFilters !== "" &&
      prevProps.RepCertificationFilters === ""
    ) {
      // console.log(month)
      // console.log(dateFormatterMoment({year,month:month,date:dt}),year,month,dt)
      const fromDateComponents =
        this.props.RepCertificationFilters.filters.dateFilters
          .filter((s) => s.selectedByDefault === "Y")[0]
          .value.split("-");
      const toDateComponents =
        this.props.RepCertificationFilters.currentDate.split("-");
      const fromDateObj = new Date(
        parseInt(fromDateComponents[0]),
        parseInt(fromDateComponents[1]) - 1,
        parseInt(fromDateComponents[2])
      );
      const toDateObj = new Date(
        parseInt(toDateComponents[0]),
        parseInt(toDateComponents[1]) - 1,
        parseInt(toDateComponents[2])
      );
      const fromDate = `${new Date(fromDateObj).getMonth() + 1}-${new Date(
        fromDateObj
      ).getDate()}-${new Date(fromDateObj).getFullYear()}`;
      const toDate = `${new Date(toDateObj).getMonth() + 1}-${new Date(
        toDateObj
      ).getDate()}-${new Date(toDateObj).getFullYear()}`;
      const minDateSplit =
        this.props.RepCertificationFilters.minMax.minDate.split("-");
      const minDate = new Date(
        parseInt(minDateSplit[0]),
        parseInt(minDateSplit[1]) - 1,
        parseInt(minDateSplit[2])
      );
      const maxDateSplit =
        this.props.RepCertificationFilters.minMax.maxDate.split("-");
      const maxDate = new Date(
        parseInt(maxDateSplit[0]),
        parseInt(maxDateSplit[1]) - 1,
        parseInt(maxDateSplit[2])
      );
      this.setState({
        ...this.state,
        minDateForTo: minDate,
        maxDateForTo: maxDate,
        minDateForFrom: minDate,
        maxDateForFrom: maxDate,
        from: fromDate,
        to: toDate,
        last: this.props.RepCertificationFilters.filters.dateFilters.filter(
          (s) => s.selectedByDefault === "Y"
        )[0].value,
        fromDisplay: customDateFormatterNew(fromDate),
        toDisplay: customDateFormatterNew(toDate),
        activeFrom: fromDate,
        activeTo: toDate,
        filtersForDrilldown: this.passFiltersForDrilldown(),
      });
    }
  }
  handleChange = (e) => {
    if (e.target.value !== 1) {
      const fromDateComponents = e.target.value.split("-");
      const toDateComponents =
        this.props.RepCertificationFilters.currentDate.split("-");
      const fromDateObj = new Date(
        parseInt(fromDateComponents[0]),
        parseInt(fromDateComponents[1]) - 1,
        parseInt(fromDateComponents[2])
      );
      const toDateObj = new Date(
        parseInt(toDateComponents[0]),
        parseInt(toDateComponents[1]) - 1,
        parseInt(toDateComponents[2])
      );
      const fromDate = `${new Date(fromDateObj).getMonth() + 1}-${new Date(
        fromDateObj
      ).getDate()}-${new Date(fromDateObj).getFullYear()}`;
      const toDate = `${new Date(toDateObj).getMonth() + 1}-${new Date(
        toDateObj
      ).getDate()}-${new Date(toDateObj).getFullYear()}`;
      this.setState({
        ...this.state,
        [e.target.name]: e.target.value,
        to: toDate,
        from: fromDate,
        errorTextFrom: "",
        errorTextTo: "",
      });
    } else {
      this.setState({ ...this.state, [e.target.name]: e.target.value });
    }
  };

  handleChangeFilter = (e) => {
    this.setState({
      ...this.state,
      [e.target.name]:
        e.target.name === "rep"
          ? [e.target.value]
          : e.target.value.length === 0
          ? ["All"]
          : this.state[e.target.name].length === 1 &&
            this.state[e.target.name].includes("All")
          ? e.target.value.filter((v) => v !== "All").length > 0
            ? e.target.value.filter((v) => v !== "All")
            : ["All"]
          : e.target.value.includes("All")
          ? ["All"]
          : e.target.value,
    });
  };

  orderRepsByLastName = () => {
    let temp = this.props.StageProgressionFilters.filters.reps;
    let reps = temp
      .map((r) => r.Full_Name)
      .map((rep) => {
        const res = rep.split(" ", 2);
        return {
          firstName: res[0],
          lastName: res[1],
          fullName: rep,
          sortName: `${res[1]} ${res[0]}`,
        };
      });
    function compare(a, b) {
      if (a.sortName < b.sortName) {
        return -1;
      }
      if (a.sortName > b.sortName) {
        return 1;
      }
      return 0;
    }
    reps.sort(compare);
    reps = [
      { firstName: "All", lastName: "All", fullName: "All", sortName: "All" },
      ...reps,
    ];
    const menuItems = reps.map((rep, index) => {
      return rep.fullName;
    });
    return menuItems;
  };

  getSelectedRepIDs = () => {
    let idArray = [];
    this.state.rep.map((i) => {
      this.props.funnelCompareFilters.map((j) => {
        if (j.type === "rep" && j.Full_Name === i) {
          idArray = [...idArray, j.UserID];
        }
      });
    });
    return idArray;
  };

  getDrilldownTitle = (key) => {
    if (key === "SAL") {
      return "SALs Assigned on or After Hire Date";
    } else if (key === "Quota") {
      return "Cumulative Quota since Hire Date";
    } else if (key === "Won") {
      return "Won from opps. assigned after Hire Date";
    } else if (key === "lost") {
      return "Lost from opps. assigned after Hire Date";
    } else if (key === "Win") {
      return "Win Rate from SQL";
    } else if (key === "Certification") {
      return "Certification Completion";
    } else {
      return "Rep Certification";
    }
  };

  handleChangeLocation = (location, ID, rep, hireDate, key) => {
    if (location !== "overview") {
      var filters = [];
      filters = [
        ...filters,
        { name: "hireDate", value: [hireDate] },
        { name: "SFDC_Owner_ID", value: [ID] },
        { name: "rep", value: [rep] },
      ];
      if (!this.state.seriesFilter.includes("All")) {
        filters = [
          ...filters,
          { name: "series", value: this.state.seriesFilter },
        ];
      }
      var drilldownfilters = [
        { title: "Hire Date", value: dateFormatterMomentV2(hireDate) },
        { title: "Rep", value: rep },
      ];
      const fromDate = `${this.state.activeFrom.split("-")[2]}-${
        this.state.activeFrom.split("-")[0]
      }-${this.state.activeFrom.split("-")[1]}`;
      const toDate = `${this.state.activeTo.split("-")[2]}-${
        this.state.activeTo.split("-")[0]
      }-${this.state.activeTo.split("-")[1]}`;
      this.props.getCertificationDrilldown(filters, key, fromDate, toDate);
      this.setState({
        location,
        drilldownTitle: this.getDrilldownTitle(key),
        key,
        DrildownFilters: [
          ...drilldownfilters,
          ...this.state.filtersForDrilldown,
        ],
      });
    } else {
      this.props.clearDrilldownData();
    }
  };

  handleChangeLocationBack = (location) => {
    this.setState({
      ...this.state,
      location: location,
    });
  };

  onRepChange = (event, value) => {
    this.setState({
      ...this.state,
      rep: [value ? value : "All"],
    });
  };

  onAcvChange = (event, value) => {
    this.setState({
      ...this.state,
      acv: value,
    });
  };

  setFromDate = (date) => {
    const split = this.state.to.split("-");
    const toDate = new Date(
      parseInt(split[2]),
      parseInt(split[0]) - 1,
      parseInt(split[1])
    );
    if (new Date(date) > toDate) {
      this.setState({
        ...this.state,
        from: `${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear()}`,
        errorTextFrom: "From date cannot be later than the To date",
      });
    } else {
      this.setState({
        ...this.state,
        from: `${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear()}`,
        errorTextFrom: "",
        errorTextTo: "",
      });
    }
  };

  setToDate = (date) => {
    const split = this.state.from.split("-");
    const fromDate = new Date(
      parseInt(split[2]),
      parseInt(split[0]) - 1,
      parseInt(split[1])
    );
    if (new Date(date) < fromDate) {
      this.setState({
        ...this.state,
        to: `${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear()}`,
        errorTextFrom: "To date cannot be earlier than the From date",
      });
    } else {
      this.setState({
        ...this.state,
        to: `${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear()}`,
        errorTextTo: "",
        errorTextFrom: "",
      });
    }
  };

  plot = () => {
    const fromSplit = this.state.from.split("-");
    const toSplit = this.state.to.split("-");

    let filters = this.filters
      .map((f) => {
        return {
          name: f,
          value:
            f === "rep"
              ? this.state[f].includes("All")
                ? this.state[f]
                : this.state[f].map(
                    (s) =>
                      this.props.StageProgressionFilters.filters.reps.filter(
                        (r) => r.Full_Name === s
                      )[0].UserID
                  )
              : f === "team"
              ? this.state[f].includes("All")
                ? this.state[f]
                : this.state[f].map(
                    (s) =>
                      this.props.StageProgressionFilters.filters.teams.filter(
                        (r) => r.Display_Name === s
                      )[0].Display_Name
                  )
              : this.state[f],
          string: "true",
        };
      })
      .filter((f) => !f.value.includes("All"))
      .filter((f) => !this.state.disabled.includes(f.name));
    /* if (this.state.acv !== null && this.state.acv !== 0) {
        filters = [
          ...filters,
          {
            name: 'acv',
            value: this.state.acv && typeof (this.state.acv) === 'string' ?
  
              this.state.acv.match(/,/g) ?
                this.state.acv.match(/,/g).length === 1 ?
                  parseInt(this.state.acv) * 1000
                  :
                  this.state.acv.match(/,/g).length === 2 ?
                    parseInt(this.state.acv) * 1000000
                    :
                    parseInt(this.state.acv)
                :
                parseInt(this.state.acv)
  
  
              : this.state.acv,
            string: false
          }
        ]
      }
   */
    //this.props.getStageProgressionData(this.state.from, this.state.to, filters)
    const fromDate = `${this.state.from.split("-")[2]}-${
      this.state.from.split("-")[0]
    }-${this.state.from.split("-")[1]}`;
    const toDate = `${this.state.to.split("-")[2]}-${
      this.state.to.split("-")[0]
    }-${this.state.to.split("-")[1]}`;
    this.props.getCertificationData(fromDate, toDate, filters);
    this.setState({
      ...this.state,
      fromDisplay: customDateFormatterNew(this.state.from),
      toDisplay: customDateFormatterNew(this.state.to),
      activeFrom: this.state.from,
      activeTo: this.state.to,
      filtersForDrilldown: this.passFiltersForDrilldown(),
      //activeFilters: filters,
      activelast: this.state.last,
      seriesFilter: this.state.series,
    });
  };

  passFiltersForDrilldown = () => {
    let filtersArray = [];

    if (!this.state.series.includes("All")) {
      filtersArray = [
        ...filtersArray,
        { title: "Series", value: this.state.series },
      ];
    }
    if (!this.state.team.includes("All")) {
      filtersArray = [
        ...filtersArray,
        { title: "Team", value: this.state.team },
      ];
    }
    // filtersArray=[...filtersArray,{title:'ACV >=',value:this.state.acv}]
    if (!this.state.Cust_Type.includes("All")) {
      filtersArray = [
        ...filtersArray,
        { title: "Customer Type", value: this.state.Cust_Type },
      ];
    }

    return filtersArray;
  };

  handleSecondLevelDrilldown = (location, oppId) => {
    console.log(oppId);
    this.setState({
      ...this.state,
      location: location,
    });
  };
  stepBack = () => {
    this.setState({
      ...this.state,
      location: "drilldownOnGraph",
    });
    this.props.clearExpectedAcvData();
  };

  render() {
    const { classes } = this.props;
    return (
      <Grid container className={classes.gridContainer}>
        {/* {addHeaderdescription(
          "Certification vs. Performance Analysis",
          "Analyze the impact of certification on performance."
        )} */}
        <AddHeaderDescriptionWithHelperText
          header={`Certification vs. Performance Analysis`}
          description={`Analyze the impact of certification on performance.`}
          helperTextCharts={this.props.helperTextCharts}
        />

        <Grid
          className={classes.grid}
          item
          style={{ marginBottom: 10, marginLeft: 25 }}
          xs={12}
        >
          {/* <Grid item xs={12} justify="center">
            <Typography variant="h2" align="center">
              Certification vs. Performance Analysis
            </Typography>
          </Grid>
          <Grid item xs={12} justify="left" style={{ margintop: 10 }}>
            <Typography variant="body1">
              Analyze the impact of certification on performance.
            </Typography>
          </Grid> */}
          {this.props.RepCertificationFilters !== "" ? (
            <>
              <Grid
                container
                xs={12}
                alignItems="flex-start"
                style={{ marginBottom: 5 }}
              >
                <Grid
                  xs={5}
                  item
                  container
                  className={classes.datesFilterContainer}
                  component={Paper}
                >
                  <Grid item xs={4} style={{ paddingTop: 0 }}>
                    <FormControl fullWidth className={classes.formControl}>
                      <InputLabel
                        id="select-last-label"
                        style={{ color: "#4472c4", whiteSpace: "nowrap" }}
                      >
                        Hiring Time Frame - Last:
                      </InputLabel>
                      <Select
                        labelId="select-last-label"
                        id="select-last"
                        value={this.state.last}
                        onChange={this.handleChange}
                        label="Last:"
                        name="last"
                        disabled={this.state.timeFrame === "custom"}
                      >
                        {[
                          { text: "Custom", value: 1 },
                          ...this.props.RepCertificationFilters.filters
                            .dateFilters,
                        ].map((y) => (
                          <MenuItem key={y.text} value={y.value}>
                            {y.text}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={4} style={{ paddingLeft: 10 }}>
                    <DatePicker
                      label="From start of:"
                      setDate={(date) => this.setFromDate(date)}
                      disabled={this.state.last !== 1}
                      min={this.state.minDateForFrom}
                      max={this.state.maxDateForFrom}
                      current={this.state.from}
                      errorText={this.state.errorTextFrom}
                    />
                  </Grid>
                  <Grid item xs={4} style={{ paddingLeft: 10 }}>
                    <DatePicker
                      label="To end of:"
                      setDate={(date) => this.setToDate(date)}
                      disabled={this.state.last !== 1}
                      min={this.state.minDateForTo}
                      max={this.state.maxDateForTo}
                      current={this.state.to}
                      errorText={this.state.errorTextTo}
                    />
                  </Grid>
                </Grid>
                <Grid
                  xs={2}
                  item
                  container
                  className={classes.datesFilterContainer}
                  component={Paper}
                >
                  <Grid item xs={12} style={{ paddingTop: 0 }}>
                    <FormControl fullWidth className={classes.formControl}>
                      <InputLabel
                        id="select-series-label"
                        style={{
                          color: !this.state.series.includes("All")
                            ? "#4472c4"
                            : "#000",
                        }}
                      >
                        Series :
                      </InputLabel>
                      <Select
                        labelId="select-series-label"
                        value={this.state.series}
                        onChange={this.handleChangeFilter}
                        label="series"
                        data-test="series"
                        name="series"
                        multiple
                      >
                        <MenuItem value={"All"}>All</MenuItem>
                        {this.props.RepCertificationFilters !== "" &&
                          this.props.RepCertificationFilters.seriesName.map(
                            (y) => (
                              <MenuItem key={y} value={y}>
                                {y}
                              </MenuItem>
                            )
                          )}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>

                {/* <Grid item xs={4} container className={classes.repTeamFilterContainer} component={Paper}  >

                <Grid item xs={6} style={{ paddingTop: 0 }}>
                  <Autocomplete
                    id="combo-box-demo"
                    options={this.props.StageProgressionFilters !== '' && this.orderRepsByLastName()}
                    getOptionLabel={(option) => option}
                    value={this.state.rep[0]}
                    onChange={this.onRepChange}
                    name='rep'
                    disabled={!this.state.team.includes('All')}
                    renderInput={(params) => <TextField  {...params} label="Rep:" variant="standard" InputLabelProps={{ style: { color: !this.state.rep.includes('All') ? '#4472c4' : '#000' } }} />}
                  />
                </Grid>
                <Grid item xs={6} style={{ paddingLeft: 10 }}>
                  <FormControl fullWidth className={classes.formControl} disabled={!this.state.rep.includes('All')}>
                    <InputLabel id="select-team-label" style={{ color: !this.state.team.includes('All') ? '#4472c4' : '#000' }}>Team:</InputLabel>
                    <Select
                      labelId="select-team-label"
                      id="select-team"
                      value={this.state.team}
                      onChange={this.handleChangeFilter}
                      label="Team"
                      name='team'
                      multiple
                    >
                      <MenuItem value={'All'}>All</MenuItem>
                      {this.props.StageProgressionFilters !== '' && this.props.StageProgressionFilters.filters.teams.map(t => t.Display_Name).sort().map(y => <MenuItem key={y} value={y}>{y}</MenuItem>)}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              */}

                {/* <Grid item container xs={2} className={classes.repTeamFilterContainer} component={Paper}  >
                <Grid item xs={12} style={{ paddingTop: 0 }}>
                <FormControl fullWidth className={classes.formControl}>
                    <InputLabel id="select-team-label" style={{ color: !this.state.Cust_Type.includes('All') ? '#4472c4' : '#000' }}>Customer Type:</InputLabel>
                    <Select
                      labelId="select-team-label"
                      id="select-cust-type"
                      data-test="select-cust-type"
                      value={this.state.Cust_Type}
                      onChange={this.handleChangeFilter}
                      label=""
                      name='Cust_Type'
                      multiple
                    >
                      <MenuItem value={'All'}>All</MenuItem>
                      {this.props.StageProgressionFilters !== '' && this.props.StageProgressionFilters.filters.custType.map(t => t.Cust_Type).map(y => <MenuItem key={y} value={y}>{y}</MenuItem>)}
                    </Select>
                  </FormControl>
                </Grid>
                </Grid>
            */}
                <Grid
                  container
                  item
                  style={{ marginBottom: 10, padding: 10 }}
                  justify="space-between"
                  xs={4}
                  lg={2}
                >
                  {/* <Grid item spacing={2} xs={8} xl={9} container component={Paper} >
                <Grid item xs={12} sm={12} style={{ paddingTop: 0, height: '0px' }}>

                  <Autocomplete
                    id="free-solo-demo"
                    freeSolo
                    options={this.props.StageProgressionFilters !== '' && this.props.StageProgressionFilters.filters.acv}
                    // options={this.props.company === 'C0001' ? ['0', '5,000', '10,000', '15,000', '20,000', '30,000', '50,000', '100,000'] : ['0', '50,000', '100,000', '250,000', '500,000', '750,000', '1,000,000']}
                    //getOptionLabel={(option) => typeof (option) === 'string' ? option : stringNumFormatter(parseInt(option))}
                    onChange={this.onAcvChange}
                    value={this.state.acv}
                    data-test="acv"
                    autoSelect={true}
                    renderInput={(params) => (
                      <TextField {...params} label="ACV >= :" margin="normal" variant="standard" style={{ marginTop: 4, }}
                        InputLabelProps={{ shrink: true, style: { color: this.state.acv !== null && this.state.acv !== 0 ? '#4472c4' : '#000' } }}
                        InputProps={{
                          ...params.InputProps,
                          inputComponent: NumberFormatCustom,
                          startAdornment: (
                            <>
                              <InputAdornment position="start">
                                $
                              </InputAdornment>
                              {params.InputProps.startAdornment}
                            </>
                          )
                        }}
                      />
                    )}
                  />

                </Grid>
              </Grid> */}
                  <Grid item xs={4} xl={3} container justify="flex-end">
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={this.plot}
                      disabled={
                        this.state.errorTextFrom !== "" ||
                        this.state.errorTextTo !== ""
                      }
                    >
                      GO
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </>
          ) : (
            <Grid
              item
              container
              component={Card}
              style={{ margin: "1rem" }}
              justify="center"
            >
              <Skeleton
                variant="react"
                animation="wave"
                height={120}
                width="90%"
                style={{ margin: "1rem" }}
              />
            </Grid>
          )}

          <Grid
            item
            xs={12}
            className={classes.grid}
            container
            justify="center"
          >
            <Grid
              item
              xs={12}
              style={{ marginBottom: "2rem", paddingBottom: "2rem" }}
            >
              <Card style={{ margin: "auto", width: "100%" }} raised={true}>
                {this.props.RepCertificationData !== "" ? (
                  <Grid item container xs={12} justify="center">
                    <Typography
                      variant="h2"
                      style={{
                        margin: "1rem",
                        display: "flex",
                        justifyContent: "center",
                        padding: "1rem",
                      }}
                    >
                      Certification vs. Performance Analysis
                    </Typography>

                    <RepCertificationTable
                      data={this.props.RepCertificationData.data}
                      handleChangeLocation={this.handleChangeLocation}
                      dataTest={"Rep Certification"}
                      Win_Rate_Prefix={this.props.Win_Rate_Prefix}
                    />
                    {this.props.RepCertificationData.data
                      .map((s) => s.showAsterisk)
                      .includes(true) && (
                      <Grid item container xs={12} justify="flex-start">
                        <Typography
                          variant="body2"
                          style={{ paddingBottom: "1rem", paddingLeft: "2rem" }}
                        >
                          <span style={{ color: "#ED7D31" }}>*</span>&nbsp; Reps
                          who are no longer active.
                        </Typography>
                      </Grid>
                    )}
                  </Grid>
                ) : (
                  <Grid item container justify="center">
                    <Skeleton
                      variant="react"
                      animation="wave"
                      height={120}
                      width="90%"
                      style={{ margin: "1rem" }}
                    />
                  </Grid>
                )}
              </Card>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            className={classes.grid}
            container
            justify="center"
          >
            <Grid
              item
              xs={12}
              style={{ marginBottom: "2rem", paddingBottom: "2rem" }}
            >
              <Card style={{ margin: "auto", width: "100%" }} raised={true}>
                {this.props.RepCertificationData !== "" ? (
                  <Grid item container xs={12} justify="center">
                    <Typography
                      variant="h2"
                      style={{
                        margin: "1rem",
                        display: "flex",
                        justifyContent: "center",
                        padding: "1rem",
                      }}
                    >
                      Certification vs. Ramp Time Analysis
                    </Typography>

                    <RepCertificationTable2
                      data={this.props.RepCertificationData.data}
                      handleChangeLocation={this.handleChangeLocation}
                      dataTest={"Rep Certification Table2"}
                      rampDays={this.props.RepCertificationData.noOfRampDays}
                    />
                    {this.props.RepCertificationData.data
                      .map((s) => s.showAsterisk)
                      .includes(true) && (
                      <Grid item container xs={12} justify="flex-start">
                        <Typography
                          variant="body2"
                          style={{ paddingBottom: "1rem", paddingLeft: "2rem" }}
                        >
                          <span style={{ color: "#ED7D31" }}>*</span>&nbsp; Reps
                          who are no longer active.
                        </Typography>
                      </Grid>
                    )}
                  </Grid>
                ) : (
                  <Grid item container justify="center">
                    <Skeleton
                      variant="react"
                      animation="wave"
                      height={120}
                      width="90%"
                      style={{ margin: "1rem" }}
                    />
                  </Grid>
                )}
              </Card>
            </Grid>
          </Grid>
        </Grid>
        {this.state.location === "drilldownOnGraph" && (
          <Grid
            item
            xs={12}
            style={{ position: "absolute", width: "100%", marginTop: "30px" }}
          >
            <SingleLevelDrilldown
              header={this.state.drilldownTitle}
              back={this.handleChangeLocationBack}
              filters={this.state.DrildownFilters}
            >
              <Drilldown
                body={this.props.drilldownOnGraphData}
                showKey={this.state.key}
                company={this.props.company}
                header={"CertificationVsPerformance"}
              />
            </SingleLevelDrilldown>
          </Grid>
        )}
      </Grid>
    );
  }
}
const mapStateToProps = (state) => {
  var {
    RepCertificationData,
    RepCertificationFilters,
    drilldownOnGraphData,
    currentFilters,
    user,
    ExpectedAcvData,
  } = state.app;

  return {
    RepCertificationData,
    RepCertificationFilters,
    drilldownOnGraphData,
    currentFilters,
    company: user.company,
    Win_Rate_Prefix: user.Win_Rate_Prefix,
    ExpectedAcvData,
    helperTextCharts: user.elements.flatMap((item) => item.charts || []),
  };
};
const mapDispatchToProps = (dispatch) => ({
  getCertificationFilters: () => {
    dispatch({ type: "get_rep_certification_filters_request" });
    appService.getCertificationFilters().then(
      (json) => {
        dispatch({ type: "get_rep_certification_filters_success", json });
        dispatch({ type: "get_rep_certification_data_request" });
        //const filters=[{name:'acv',value:20000,string:false}]
        //dispatch({ type: 'current_selected_filters', filters })
        appService
          .getCertificationData(
            json.message.filters.dateFilters.filter(
              (s) => s.selectedByDefault === "Y"
            )[0].value,
            json.message.currentDate,
            []
          )
          .then(
            (json) => {
              dispatch({ type: "get_rep_certification_data_success", json });
            },
            (error) => {
              if (typeof error === "object")
                dispatch({
                  type: "get_rep_certification_data_failure",
                  error: "Something went wrong",
                });
              else
                dispatch({ type: "get_rep_certification_data_failure", error });
            }
          );
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_rep_certification_filters_failure",
            error: "Something went wrong",
          });
        else dispatch({ type: "get_rep_certification_filters_failure", error });
      }
    );
  },
  getCertificationDrilldown: (filters, key, from, to) => {
    dispatch({ type: "get_drilldown_on_graph_request" });
    appService.getCertificationDrilldown(filters, key, from, to).then(
      (json) => {
        let tempOpportunities = ["Quota", "Certification"].includes(key)
          ? json.message.opportunities[1]
          : json.message.opportunities[1].sort((a, b) =>
              a.ACV > b.ACV ? -1 : 1
            );
        tempOpportunities = tempOpportunities.map((item, index) => {
          let temp = {
            ...item,
            OppNo: index + 1,
          };
          return temp;
        });

        json.message = {
          ...json,
          columns: json.message.columns,
          count_acv: json.message.opportunities[0],
          opportunities: tempOpportunities,
        };
        dispatch({ type: "get_drilldown_on_graph_success", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_drilldown_on_graph_failure",
            error: "Something went wrong",
          });
        else dispatch({ type: "get_drilldown_on_graph_failure", error });
      }
    );
  },
  clearDrilldownData: () => {
    dispatch({ type: "clear_drilldown_data" });
  },
  getCertificationData: (from, to, filters) => {
    dispatch({ type: "get_rep_certification_data_request" });
    //dispatch({ type: 'current_selected_filters', filters })
    appService.getCertificationData(from, to, filters).then(
      (json) => {
        dispatch({ type: "get_rep_certification_data_success", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_rep_certification_data_failure",
            error: "Something went wrong",
          });
        else dispatch({ type: "get_rep_certification_data_failure", error });
      }
    );
  },
  getOpenOppData: (oppId) => {
    dispatch({ type: "get_expectedAcv_drilldown_data_request" });
    appService.getWaterfallOppData(oppId).then(
      (json) => {
        dispatch({ type: "get_expectedAcv_drilldown_data_success", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_expectedAcv_drilldown_data_failure",
            error: "Something went wrong",
          });
        else
          dispatch({ type: "get_expectedAcv_drilldown_data_failure", error });
      }
    );
  },
  clearExpectedAcvData: () => {
    dispatch({ type: "clear_expected_acv_data" });
  },
});
const connectedRepCertification = connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(RepCertification));
export default connectedRepCertification;
